export default __webpack_public_path__ + "static/media/logo_header.3b362522.png";